Easie = require("lib/easie")

class ScoreModel extends Backbone.Model
  defaults:
    turns: 0

  initialize: ->
    @on "reset", @resetScore, this
    @on "tally", @tallyScore, this
    @on "change", @getTotal, this

  resetScore: ->
    window.clearTimeout @timeout

    @set
      score: 0
      total: 0
      correct: 0
      incorrect: 0
      consecutive: 0
      lastScore: 0

  # Once the game has ended, "tally up" the scores into the combined score.
  tallyScore: ({callback, ms, tallyFrom}) ->
    window.clearTimeout @timeout

    { score, record, total } = @attributes

    if score is total and total is record and not tallyFrom?
      callback?()
    else
      start   = Date.now()
      fps     = 1000 / 60
      frame   = 0
      initial = tallyFrom or 0
      ms     ?= 3000
      ms      = Math.min(ms, Math.abs(initial - score) or 1)
      frames  = ms / fps

      do repeat = =>
        dist = _.limit((frame / frames) or 0, 1)
        dist = 1 unless 0 <= dist <= 1

        attrs =
          total: Math.round(
            Easie.quartInOut(dist, initial, (score - initial), 1)
          )

        attrs.record = Math.max(attrs.total, record or 0) unless tallyFrom?

        @set attrs

        if frame < frames
          @timeout = window.setTimeout(repeat, fps)
          frame = Math.floor((Date.now() - start) / fps)
        else
          callback?()

  # When scores change, ensure the total still represents the score
  getTotal: (e) ->
    unless e.changed.total or not e.changed.score?
      @set total: @get("score")

  # Similar to set, this function allows an increase/decrease to numerical
  # attributes by an amount rather than getting and setting. Allows either
  # (key, val) or ({key, val}) syntax.
  setBy: (obj, amount) ->
    if typeof obj is "string"
      key = obj
      obj = {}
      obj[key] = amount
    else
      opts = amount

    for key, val of obj
      prev = @get(key)
      @set(key, Math.max(prev + val, 0), opts)

      if key is "lastScore"
        console?.log?("`lastScore` cannot be set")
        return

      if key is "score" and val > 0
        @set({lastScore: 0}, silent: true)
        @set(lastScore: val)

  destroy: ->
    window.clearTimeout @timeout
    super

module.exports = ScoreModel
